import styled from "styled-components";

interface ISelectContainer {
  height?: string;
  width?: string;
  arrowPosition?: string;
}
export const SelectContainer = styled.div<ISelectContainer>`
  ${(props) => `
    height: ${props.height ? props.height : "auto"};
    width: ${props.width ? props.width : "auto"};
  `}

  position: relative;

  &:after {
    ${(props) => `
    top: ${props.arrowPosition ? props.arrowPosition : "40%"};
  `}
    color: ${(props) =>
      props.theme.colors.blackTextBody + props.theme.transparencies.p58};
    content: "\f078";
    font: normal normal normal 10px/1 FontAwesome;
    position: absolute;
    pointer-events: none;
    right: 5px;
  }
`;

interface ISelectElement {
  hasError?: any;
}
export const SelectElement = styled.select<ISelectElement>`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
    border: ${
      props.hasError ? "solid 1px " + props.theme.colors.accentRed : "none"
    };
  `}
  background-color: ${(props) => props.theme.colors.white};
  appearance: none;
  display: block;
  border-radius: 8px;
  box-shadow: 0px 5px 30px rgb(231 231 234 / 62%);
  height: 100%;
  font-size: 1.4rem;
  font-weight: 500;
  padding: 0 2rem 0 1rem;
  width: 100%;

  &:focus {
    outline: none;
  }
`;
